const labelSizeInPx = 25;
const minPipSizeInPx = 5;
const maxValToDisplay = 999;

export {
    labelSizeInPx,
    minPipSizeInPx,
    maxValToDisplay
};
